import './ProjectDetails.css'

function ProjectDetails(props) {
    // Add safety checks to prevent accessing undefined values
    const slideIndex = typeof props.slideIndex === 'number' ? props.slideIndex : 0;
    const projectMetas = props.projectMetas || [];
    const projectIndex = typeof props.projectIndex === 'number' ? props.projectIndex : 0;
    const fontJsons = props.fontJsons || [];
    const typefaceSwiperIndex = typeof props.typefaceSwiperIndex === 'number' ? props.typefaceSwiperIndex : 0;

    // Make sure we have valid data before accessing nested properties
    let json;
    if (props.selectedPage === 0 && projectMetas[projectIndex] && projectMetas[projectIndex][slideIndex]) {
        json = projectMetas[projectIndex][slideIndex];
    } else if (fontJsons[typefaceSwiperIndex]) {
        json = fontJsons[typefaceSwiperIndex];
    } else {
        // Provide a fallback if data is not available
        json = { title: '', information: '', meta_information: '', additional_information: '', year: '' };
    }

    return (
        <div className='project-details-container'>
            <div className='grid grid-cols-14 w-full gap-4 items-center h-full'>
                <div className='col-span-2 h-full flex items-center'></div>

                {/* Content spanning 7 columns */}
                <div className='col-span-7 flex flex-col gap-4 h-full justify-center'>
                    <div className='font-screen-monitor leading-normal text-[clamp(12px,1.5vw,18px)]'>
                        {json.details_title}
                    </div>
                    <div>
                        {typeof json.information === 'string' && (
                            <>
                                <span className='font-screen-monitor leading-normal text-[clamp(12px,1.5vw,18px)]' dangerouslySetInnerHTML={{ __html: json.information }}>
                                </span>
                                <br />
                                <br />
                            </>
                        )}
                        <span className='leading-normal text-[clamp(8px,1vw,12px)]'>
                            {json.meta_information}
                        </span>
                    </div>
                </div>

                <div className='col-span-2 h-full flex items-center'></div>

                {/* Additional information spanning 1 column */}
                <div className='col-span-2 font-semi-bold leading-normal text-[clamp(8px,1vw,12px)] h-full flex items-center' style={{ maxWidth: '225px' }} dangerouslySetInnerHTML={{ __html: json.additional_information }}>
                </div>

                {/* Year in the last column */}
                <div className='col-span-1 font-semi-bold leading-normal text-[clamp(8px,1vw,12px)] h-full flex items-center justify-self-end' style={{ whiteSpace: 'nowrap' }}>
                    {json.year}
                </div>
            </div>
        </div>
    )
}

export default ProjectDetails;